import { Button, Text, Flex } from '@chakra-ui/react';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import React, { ReactElement } from 'react';
import { Breakpoints } from 'types/breakpoints';
import { ModalStopEditingVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalStopEditingVariantProps;

export const StopEditingModal = ({ handleClose, isShown, onStopEditing }: Props): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);

  const handleStopEditing = (): void => {
    if (onStopEditing) onStopEditing();
    handleClose();
  };
  return (
    <CustomModal
      isOpen={isShown}
      onClose={handleStopEditing}
      placement="center"
      size="md"
      hideHeader={!isDesktop}
    >
      <CustomModalContent
        p={{ base: '40px 30px', md: '0 40px 30px' }}
        display="flex"
        flexDirection="column"
      >
        <Flex textAlign="left" mb="30px" flexDir="column" gap="15px">
          <Text textStyle="h3.medium">Achtung</Text>
          <Text>
            Du hast deine Änderungen nicht gespeichert. Möchtest du die Einstellungen wirklich
            verlassen?
          </Text>
        </Flex>
        <Flex
          justifyContent="flex-end"
          w="full"
          h="fit-content"
          borderTop="none"
          borderColor="border.accent"
          p="0"
        >
          <Button
            onClick={handleClose}
            bg="transparent"
            w="220px"
            h="40px"
            borderRight="none"
            borderColor="border.accent"
            borderRadius="none"
            textStyle="h4.regular"
            fontWeight="normal"
            color="text.secondary"
            _hover={{ bg: 'transparent' }}
          >
            Weiter anpassen
          </Button>
          <Button
            variant="primary"
            minW={{ base: '150px', md: '220px' }}
            _hover={{ opacity: '80' }}
            onClick={handleStopEditing}
          >
            Schließen
          </Button>
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
